// extracted by mini-css-extract-plugin
export default {"donutTooltip":"DonutTooltip_donutTooltip__AywA1","donutTooltip__title":"DonutTooltip_donutTooltip__title__hO98F","donutTooltip__body":"DonutTooltip_donutTooltip__body__z229k"};